import { useEffect, useState } from "react";
import Input from "./Input";

// A typical debounced input react component
export default function DebouncedInput({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}) {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);

    //onChange(value);
  }, [value]);

  return (
    <Input
      elementtype="input"
      {...props}
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}
